import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { InterventionZone } from "./components/InterventionZone";
import { ProjectsSection } from "./components/ProjectsSection";
import { GallerySection } from "./components/GallerySection";
import { NewsSection } from "./components/NewsSection";
import { BlogSection } from "./components/BlogSection";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { ContactSection } from "./components/ContactSection";
import { PartnersSection } from "./components/PartnersSection";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import Lenis from "@studio-freight/lenis";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <ScrollToTop />
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/services" element={<ServicesSection />} />
            <Route path="/zone" element={<InterventionZone />} />
            <Route path="/projects" element={<ProjectsSection />} />
            <Route path="/gallery" element={<GallerySection />} />
            <Route path="/why" element={<WhyChooseUs />} />
            <Route path="/testimonials" element={<TestimonialsSection />} />
            <Route path="/partners" element={<PartnersSection />} />
            <Route path="/news" element={<NewsSection />} />
            <Route path="/blog" element={<BlogSection />} />
            <Route path="/contact" element={<ContactSection />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
